import classNames from 'classnames'
import { Dispatch, SetStateAction, useEffect, useRef } from 'react'
import useTranslation from '../../../../modules/i18n/useTranslation'

interface TabItemType {
  title: string
  subtitle?(key: number): string
  value?: number
  tab?: number
}
interface WideRectangleTabsPropsType {
  activeIndex: string | number
  setActiveIndex: Dispatch<SetStateAction<string | number>>
  tabList: TabItemType[]
}

const WideRectangleTabs = ({ activeIndex, setActiveIndex, tabList }: WideRectangleTabsPropsType) => {
  const { t } = useTranslation()
  const carouselRef = useRef<HTMLDivElement>()
  const handleClick = (value) => setActiveIndex(value)
  const checkActive = (value, classNameActive, classNameInActive = '') =>
    activeIndex === value ? classNameActive : classNameInActive
  useEffect(() => {
    const carouselIndex = tabList.findIndex((v) => v.value === activeIndex)
    if (typeof carouselRef.current?.scrollTo === 'function') {
      // element.scrollIntoView({ behavior: 'smooth' })
      const leftElement = carouselRef.current.children[carouselIndex] as HTMLElement
      carouselRef.current.scrollTo({
        left: leftElement?.offsetLeft - 20,
        behavior: 'smooth',
      })
    }
  }, [activeIndex, tabList])

  return (
    <div>
      <div
        className="scrollbar-hide flex overflow-y-hidden overflow-x-scroll p-[4px] tracking-tight first:pl-[20px] last:pr-[20px]"
        ref={carouselRef}
      >
        {tabList?.map((tabItem) => (
          <button
            key={tabItem?.value + 'tabItem'}
            onClick={() => handleClick(tabItem.value)}
            className={classNames(
              'mr-[12px] flex h-[80px] w-[94px] flex-auto flex-shrink-0 flex-col items-center justify-center rounded-[5px] p-[4px] text-center text-[14px] shadow',
              checkActive(tabItem?.value, 'border border-purple-500 bg-purple-50', 'border border-gray-100 bg-white')
            )}
          >
            <span className={classNames('font-bold', checkActive(tabItem?.value, 'text-purple-500', 'text-gray-700'))}>
              {t(tabItem?.title)}
            </span>
            {tabItem?.subtitle && (
              <span className={classNames('mt-[4px]', checkActive(tabItem?.value, 'text-gray-700', 'text-gray-500'))}>
                {tabItem.subtitle(Number(tabItem.tab))}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  )
}

export default WideRectangleTabs
